import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AnyProgressBarWidgetStyles,
  DiscountMessageBoxWidget,
  DottedJoin,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setQuantityWidgetStyleSettings,
} from "../../../store/slices/widgets";
import {
  IgColorPickerGroup,
  IgColorPickerGroupItems,
} from "../../../utils/IgColorPickerGroup";

interface MessageBoxWidgetAppearanceSettingsProps {
  configType: "desktop" | "mobile";
}

export const DiscountMessageBoxWidgetAppearanceSettings = ({
  configType,
}: MessageBoxWidgetAppearanceSettingsProps) => {
  const messageBoxWidget = useSelector(
    selectedWidget
  ) as DiscountMessageBoxWidget;
  const dispatch = useDispatch();
  const items = useMemo<IgColorPickerGroupItems>(() => {
    return [
      [
        {
          key: "containerBackgroundColor",
          label: "Background Color",
          path: `config[${configType}].styles.container.backgroundColor`,
          value:
            messageBoxWidget?.config[configType]?.styles?.container
              ?.backgroundColor ||
            messageBoxWidget?.config.desktop?.styles?.container
              ?.backgroundColor ||
            "",
        },
        {
          key: "testColor",
          label: "Text Color",
          path: `config[${configType}].styles.container.textColor`,
          value:
            messageBoxWidget?.config[configType]?.styles?.container
              ?.textColor ||
            messageBoxWidget?.config.desktop?.styles?.container?.textColor ||
            "",
        },
      ],
    ];
  }, [messageBoxWidget]);

  const onFieldChange = (
    key: DottedJoin<AnyProgressBarWidgetStyles>,
    value: string
  ) => {
    dispatch(setQuantityWidgetStyleSettings({ key, value }));
  };

  return (
    <Grid container item direction={"column"} rowGap={2}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
          Message Box Colors
        </IgTypography>
      </Grid>
      <Grid item>
        <IgColorPickerGroup
          id={"message-box-widget"}
          items={items}
          onChange={onFieldChange}
          disabled={false}
        />
      </Grid>
    </Grid>
  );
};
